import PropTypes from 'prop-types';
import { Box } from 'roo-ui/components';
import { RefundDisclaimer } from 'components/Disclaimers';
import { LineItem } from 'components/payments/primitives';
import * as propTypes from 'components/payments/propTypes';

const PointsLineItem = ({ total, paymentMethods }) => (
  <LineItem title="Qantas Points" totals={[total]}>
    {paymentMethods.map((points, index) => (
      <Box key={index}>
        Refund will be made to <strong>Qantas Frequent Flyer number {points.qffNumber}</strong>
        <RefundDisclaimer.Link />
      </Box>
    ))}
  </LineItem>
);

PointsLineItem.propTypes = {
  total: propTypes.total.isRequired,
  paymentMethods: PropTypes.arrayOf(propTypes.pointsPaymentMethod).isRequired,
};

export default PointsLineItem;
